(function () {
    'use strict';
    angular.module('wamasysApp').factory('WebNotificationPush', WebNotificationPush);
    WebNotificationPush.$inject = ['$http', '$q', '$rootScope', '$window'];
    function WebNotificationPush($http, $q, $rootScope, $window) {
        var current, config, sdkPromise, messaging, unsubscribe, activation, cleanup = $q.when(), revision = 0;
        var state = {available: false, enabled: false, busy: false, error: null};
        var version = '10.14.1';
        return {state: state, configure: configure, enable: enable, disable: disable, disconnect: disconnect,
            checkPermission: function () {
                if (current && state.enabled && $window.Notification.permission !== 'granted') { disable(current); }
            }};

        function key(context) { return 'wamasys-web-push:' + $window.location.origin + ':' + context.accountKey; }
        function stored(context) {
            try { return JSON.parse($window.localStorage.getItem(key(context)) || '{}'); } catch (ignore) { return {}; }
        }
        function save(context, value) { try { $window.localStorage.setItem(key(context), JSON.stringify(value)); } catch (ignore) { } }
        function supported() {
            return $window.location.protocol === 'https:' && $window.Notification && $window.navigator.serviceWorker
                && $window.PushManager && $window.fetch && $window.AbortController;
        }
        function valid(context) { return context && current === context; }
        function bounded(promise, milliseconds) {
            var deferred = $q.defer(), finished = false;
            var timer = $window.setTimeout(function () {
                if (!finished) { finished = true; deferred.reject(new Error('Délai de réponse dépassé.')); }
            }, milliseconds);
            $q.when(promise).then(function (result) {
                if (!finished) { finished = true; $window.clearTimeout(timer); deferred.resolve(result); }
            }, function (error) {
                if (!finished) { finished = true; $window.clearTimeout(timer); deferred.reject(error); }
            });
            return deferred.promise;
        }
        function configure(context, wake) {
            revision++; current = context; config = null; state.error = null; state.enabled = false;
            state.available = false; state.busy = false; context.wake = wake;
            if (!supported()) { return; }
            $http.get('api/notifications/push/config', {cache: false, timeout: 10000}).then(function (response) {
                if (!valid(context)) { return; }
                config = response.data;
                state.available = !!(config.enabled && config.firebaseConfig && config.vapidPublicKey);
                if (state.available && stored(context).optedIn && $window.Notification.permission === 'granted') {
                    activate(context).catch(angular.noop);
                }
            }, angular.noop);
        }
        function script(url) {
            var deferred = $q.defer(), element = $window.document.createElement('script');
            element.src = url; element.async = true; element.referrerPolicy = 'no-referrer';
            element.onload = function () { deferred.resolve(); };
            element.onerror = function () { deferred.reject(new Error('Chargement Firebase impossible.')); };
            $window.document.head.appendChild(element);
            return bounded(deferred.promise, 10000).catch(function (error) {
                if (element.parentNode) { element.parentNode.removeChild(element); }
                return $q.reject(error);
            });
        }
        function sdk() {
            if (!sdkPromise) {
                sdkPromise = script('https://www.gstatic.com/firebasejs/' + version + '/firebase-app-compat.js')
                    .then(function () { return script('https://www.gstatic.com/firebasejs/' + version + '/firebase-messaging-compat.js'); })
                    .catch(function (error) { sdkPromise = null; return $q.reject(error); });
            }
            return sdkPromise;
        }
        function enable(context) {
            if (!valid(context) || !state.available || state.busy) { return $q.when(); }
            state.error = null;
            // Cet appel reste directement dans le gestionnaire du clic : aucune demande au chargement.
            return $q.when($window.Notification.requestPermission()).then(function (permission) {
                if (!valid(context)) { return; }
                if (permission !== 'granted') { state.error = 'Les notifications ne sont pas autorisées dans ce navigateur.'; return; }
                var record = stored(context); record.optedIn = true; save(context, record);
                return activate(context);
            });
        }
        function activate(context) {
            state.busy = true;
            var settings = config, record = stored(context), registration;
            if (!record.installationId) {
                var bytes = new Uint32Array(4); $window.crypto.getRandomValues(bytes);
                record.installationId = 'web-' + Array.prototype.map.call(bytes, function (n) { return n.toString(16); }).join('-');
                save(context, record);
            }
            activation = cleanup.then(sdk).then(function () {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                if (!$window.firebase.messaging.isSupported()) { throw new Error('Notifications non prises en charge.'); }
                var name = 'wamasys-notifications-' + settings.firebaseConfig.projectId;
                var app = $window.firebase.apps.filter(function (candidate) { return candidate.name === name; })[0]
                    || $window.firebase.initializeApp(settings.firebaseConfig, name);
                messaging = app.messaging();
                return bounded($window.navigator.serviceWorker.register('/firebase-messaging-sw.js', {scope: '/firebase-push/'}), 10000);
            }).then(function (result) {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                registration = result;
                // register() peut renvoyer un worker encore en installation.
                if (registration.active) { return; }
                return bounded($q(function (resolve, reject) {
                    var worker = registration.installing || registration.waiting;
                    if (!worker) { reject(new Error('Activation du service de notifications impossible.')); return; }
                    worker.addEventListener('statechange', function () {
                        if (worker.state === 'activated') { resolve(); }
                        if (worker.state === 'redundant') { reject(new Error('Installation du service de notifications impossible.')); }
                    });
                }), 10000);
            }).then(function () {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                return bounded(messaging.getToken({vapidKey: settings.vapidPublicKey, serviceWorkerRegistration: registration}), 15000);
            }).then(function (token) {
                if (!valid(context)) { throw new Error('Session modifiée.'); }
                return $http.put('api/notifications/push/subscription', {
                    installationId: record.installationId, token: token, permission: true
                }, {timeout: 10000});
            }).then(function () {
                if (!valid(context)) { return; }
                state.enabled = true;
                if (unsubscribe) { unsubscribe(); }
                unsubscribe = messaging.onMessage(function () {
                    $rootScope.$evalAsync(function () { if (valid(context)) { context.wake(); } });
                });
            }).catch(function (error) {
                if (valid(context)) { state.error = 'Activation impossible. La boîte de réception reste disponible.'; }
                return $q.reject(error);
            }).finally(function () { if (valid(context)) { state.busy = false; } });
            return activation;
        }
        function removeSubscription(context) {
            if (!context || !$window.fetch || !$window.AbortController) { return $q.when(); }
            var record = stored(context);
            if (!record.installationId) { return $q.when(); }
            var controller = new $window.AbortController();
            var timer = $window.setTimeout(function () { controller.abort(); }, 3000);
            // Snapshot du JWT uniquement dans la page : jamais dans le service worker ni dans son URL.
            return $q.when($window.fetch('/api/notifications/push/subscription?installationId=' + encodeURIComponent(record.installationId), {
                method: 'DELETE', headers: {Authorization: 'Bearer ' + context.token},
                credentials: 'same-origin', signal: controller.signal
            })).catch(angular.noop).finally(function () { $window.clearTimeout(timer); });
        }
        function disconnect(context) {
            if (!context) { return; }
            revision++;
            if (current === context) { current = null; }
            state.enabled = false; state.available = false; state.busy = false;
            if (unsubscribe) { unsubscribe(); unsubscribe = null; }
            var oldMessaging = messaging; messaging = null;
            var oldActivation = activation; activation = null;
            // La déconnexion n'attend pas le réseau ; la prochaine activation attend le nettoyage.
            // Attendre un éventuel PUT déjà parti, sinon sa réponse tardive réinscrirait un utilisateur déconnecté.
            cleanup = $q.when(oldActivation).catch(angular.noop).then(function () {
                // Le SDK n'expose pas d'annulation ; ne pas bloquer la session suivante indéfiniment.
                var revoke = oldMessaging ? bounded(oldMessaging.deleteToken(), 5000).catch(angular.noop) : $q.when();
                return $q.all([removeSubscription(context), revoke]);
            });
            return cleanup;
        }
        function disable(context) {
            if (!context) { return $q.when(); }
            var record = stored(context); record.optedIn = false; save(context, record);
            var settings = config;
            var pending = disconnect(context), operationRevision = revision;
            return $q.when(pending).finally(function () {
                if (revision !== operationRevision) { return; }
                current = context; config = settings; state.available = !!(settings && settings.enabled);
            });
        }
    }
}());
